import { cn } from "@core-ui/utils/cn";
import { ComponentVariantProvider } from "@ui-kit/Providers";
import { GlassToolbar as UiKitGlassToolbar } from "ics-ui-kit/components/glass-toolbar";
import { forwardRef } from "react";
import type { ExtractComponentGeneric } from "../../lib/extractComponentGeneric";

export type GlassToolbarProps = ExtractComponentGeneric<typeof UiKitGlassToolbar>;

export const GlassToolbar = forwardRef<HTMLDivElement, GlassToolbarProps>((props, ref) => {
	const { className, ...otherProps } = props;
	return (
		<ComponentVariantProvider variant="glass">
			<UiKitGlassToolbar className={cn("p-1 h-10", className)} ref={ref} {...otherProps} />
		</ComponentVariantProvider>
	);
});
